import { cn } from '@/lib/utils';

export function ViewSelectorButton({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        'flex w-1/3 items-center justify-center gap-1 border-2 border-emerald-500 bg-emerald-500 px-2 py-1.5 text-sm text-white transition-colors first:rounded-l-md last:rounded-r-md hover:cursor-pointer hover:bg-emerald-400 focus:ring-2 focus:ring-emerald-300',
        className,
      )}
    >
      {children}
    </button>
  );
}
